// src/features/ClientAnalysis/hooks/useClientData.js
import { useState, useEffect, useMemo } from 'react';
import { getData } from '../../../services/storageService';
import { CLIENTS } from '../../../data/clients';

// Створюємо конфігурацію клієнтів
export const CLIENT_CONFIG = CLIENTS.reduce((config, client) => {
  config[`client_${client.code}`] = { 
    label: `${client.name} (${client.code})`, 
    unit: 'kg', 
    type: 'weight', 
    color: 'primary',
    clientCode: client.code,
    clientName: client.name
  };
  return config;
}, {});

export const useClientData = (selectedClient = null) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const allRecords = await getData('lainsa_records');
        console.log('Loaded client records:', allRecords);
        setRecords(Array.isArray(allRecords) ? allRecords : []);
      } catch (err) {
        console.error('Error loading client data:', err);
        setError('Failed to load client data');
        setRecords([]);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Обробляємо дані для всіх клієнтів
  const allClientsData = useMemo(() => {
    const result = {};
    
    Object.keys(CLIENT_CONFIG).forEach(clientKey => {
      const clientCode = CLIENT_CONFIG[clientKey].clientCode;
      const clientRecords = records
        .filter(record => {
          const hasData = record.recordType === 'shift_report' && 
                         record.pesoCliente && 
                         record.pesoCliente[clientCode] !== undefined &&
                         record.pesoCliente[clientCode] !== null &&
                         record.pesoCliente[clientCode] !== '';
          
          if (hasData) {
            console.log(`Found data for client ${clientCode}:`, record.pesoCliente[clientCode]);
          }
          
          return hasData;
        })
        .map(record => ({
          date: record.fecha,
          value: Number(record.pesoCliente[clientCode]) || 0,
          shift: record.turno,
          operators: record.operators
        }))
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      console.log(`Client ${clientCode} records:`, clientRecords);

      // Розраховуємо статистику
      const values = clientRecords.map(r => r.value).filter(v => v > 0);
      const statistics = values.length > 0 ? {
        total: values.reduce((a, b) => a + b, 0),
        average: values.reduce((a, b) => a + b, 0) / values.length,
        max: Math.max(...values),
        min: Math.min(...values),
        daysWithData: values.length,
        recordsCount: clientRecords.length
      } : {
        total: 0, average: 0, max: 0, min: 0, daysWithData: 0, recordsCount: 0
      };

      result[clientKey] = {
        data: clientRecords,
        statistics,
        config: CLIENT_CONFIG[clientKey]
      };
    });

    return result;
  }, [records]);

  // Дані для обраного клієнта
  const selectedClientData = selectedClient ? allClientsData[selectedClient] : null;

  console.log('Selected client data:', selectedClient, selectedClientData);

  return {
    allClientsData,
    selectedClientData,
    loading,
    error,
    clientsConfig: CLIENT_CONFIG
  };
};


